import styled from 'styled-components';

export const Container = styled.div``;
export const TravelarInformation = styled.div`
  font-size: 14px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  background: #ffffff;
  padding: 32px;
  border-radius: 24px;
  box-shadow: 0 20px 40px rgba(15, 23, 42, 0.05);
  @media (max-width: 768px) {
    padding: 20px;
  }
`;
export const InformationHeader = styled.h4`
  text-transform: capitalize;
  text-align: left;
  font-size: 22px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
`;

export const Select = styled.select`
  padding: 0.575rem 0.75rem;
  border: 1px solid #d7deea;
  border-radius: 12px;
  background: #fff;
  min-width: 120px;
  &&:focus-visible {
    border-color: #2563eb;
    box-shadow: 0 0 0 3px rgb(37 99 235 / 20%);
    outline: none;
  }
`;

export const FormSection = styled.div`
  background: #fff;
  border: 1px solid #e6eaf2;
  border-radius: 24px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  box-shadow: 0 20px 40px rgba(15, 23, 42, 0.05);
  label {
    text-transform: capitalize;
    font-weight: 600;
    color: #0f172a;
  }
  @media (max-width: 576px) {
    padding: 18px;
  }
`;
export const CheckboxWrapper = styled.div`
  text-align: left;
  margin-top: 20px;
`;
export const Label = styled.label`
  margin-left: 5px;
  cursor: pointer;
`;

export const SingleTravellerInformationWrapper = styled.div`
  margin-top: 40px;
`;
export const Input = styled.input`
  cursor: pointer;
`;
